import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";

import FormikDetailsPanel from "../../forms/formik/FormikDetailsPanel/FormikDetailsPanel.jsx";
import FormikAPIErrorMessage from "../../forms/formik/FormikAPIErrorMessage.jsx";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class WizardDetailsPanel extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  // -- RENDER -- //

  render() {
    const { id, apiErrors, copy } = this.props;

    return (
      <Fragment>
        <Header as="h3" attached="top" block>
          {copy("project_wizard.details_panel.title")}
        </Header>
        <Segment clearing={true} attached>
          <p>{copy("project_wizard.details_panel.body")}</p>

          <FormikAPIErrorMessage
            name={id}
            segment={true}
            apiErrors={apiErrors}
          />

          <FormikDetailsPanel
            id="details"
            apiErrors={apiErrors}
            copyKey={"project_wizard.details_panel"}
          />
        </Segment>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(WizardDetailsPanel);
